module.exports = __webpack_public_path__ + "static/cssPanel@2x-7b3e348598ca6b3d2b7cfc92d1c1e53f.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/cssPanel@2x.png
// module id = 2601
// module chunks = 168707334958949